import script from "./DesignerCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignerCanvas.vue?vue&type=script&setup=true&lang=js"

import "./DesignerCanvas.vue?vue&type=style&index=0&id=36b2ee68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b2ee68"]])

export default __exports__